<template>
    <div class="login_box">
        <div class="run_title">
            <img src="../../assets/login/logo-across.png" style="height: 40px;margin: 10px 0">
        </div>
        <div class="centerCon">
            <div class="login-img">
                <img src="../../assets/login/login_bg.png"/>
            </div>
            <div class="content">
                <div class="loginCon">
                    <div style="text-align: left;font-size: 16px; padding: 10px 40px">用户注册</div>
                </div>
                <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" class="login_form_box fl" style="padding: 10px 40px">
                    <el-form-item prop="form_mobile">
                        <el-input v-model="ruleForm2.form_mobile" type="text" auto-complete="off"
                                  placeholder="请输入手机号码" />
                    </el-form-item>
                    <!-- 滑动 -->
                    <!-- <el-form-item prop="identify_code">
                     <div class="form-inline-input">
                      <div class="code-box" id="code-box" style="width:98%" >
                      <input type="text" name="code" class="code-input" />
                      <p></p>
                      <span :class="verification==true?'greenV':'redV' " >
                          <i class="el-icon-right" v-if="!verification" ></i>
                          <i class="el-icon-check" v-else="verification" ></i>
                      </span>
                      </div>
                     </div>
                    </el-form-item> -->

                    <el-form-item prop="sms_code">
                        <el-input type="text" v-model="ruleForm2.sms_code" auto-complete="off" placeholder="请输入短信验证码">
                            <template slot="append">
                                <el-button v-if="sendMobileCode" @click="sendMobile">获取短信验证码</el-button>
                                <el-button v-if="!sendMobileCode">{{ limit_time }}秒后重新发送验证码</el-button>
                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input type="password" v-model="ruleForm2.password" auto-complete="new-password"
                                  placeholder="设置8-20位字符,包含字母和数字" />
                    </el-form-item>
                    <el-form-item prop="re_password">
                        <el-input type="password" v-model="ruleForm2.re_password" auto-complete="new-password"
                                  placeholder="确认密码,8-20位字符,包含字母和数字" />
                    </el-form-item>
                    <el-form-item style="width:100%;">
                        <el-button type="FF7" @click="submitForm('ruleForm2')" :loading="loading" style="width:100%;">
                            确认注册
                        </el-button>
                    </el-form-item>
                    <el-form-item prop="rule_checked">
                        <span class="link_btn fl">
                            <el-checkbox v-model="ruleForm2.rule_checked" />
                            <span style="color:#9b9b9b;">已阅读并同意</span>
                          <span v-if="helpList.length == 0">《用户使用协议》</span>
                          <span v-if="helpList.length > 0" v-for="(item,index) in helpList" :key="index"  >
                            <span v-if="index > 0">及</span>
                            <a class="link_btn " style="display: inline-block" :href="item.help_url" target="_blank">《{{ item.help_title }}》</a>
                          </span>

						</span>
                    </el-form-item>
                    <el-form-item>
                        <router-link class="link_btn fl" to="/login"><i class="el-icon-back" />已有账号，立即登录</router-link>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="login-footer" v-html="copyRight"></div>
    </div>

</template>

<script>
    import {isPassword, validatePhone} from '@/common/js/validator'
    import md5 from 'md5';

    export default {
        data() {
            //验证两次密码是否一致
            const validateRePassword = (rule, value, callback) => {
                if (value !== this.ruleForm2.password) {
                    callback(new Error('两次密码不一致'))
                }
            }
            return {
                verification: false,
                identifyCode: false,
                copyRight: '',
                sms_type: 'register',
                sendMobileCode: true,
                limit_time: 0,
                loading: false,

                ruleForm2: {
                    form_mobile: '',
                    sms_code: '',
                    password: '',
                    re_password: '',
                    rule_checked: true
                },
                rules2: {
                    sms_code: [
                        {required: true, message: '请输入短信验证码', trigger: 'blur'}
                    ],
                    form_mobile: [
                        {required: true, message: '请输入手机号码', trigger: 'blur'},
                        {validator: validatePhone, trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '请输入密码', trigger: 'blur'},
                        {validator: isPassword, trigger: 'blur'},
                    ],
                    re_password: [
                        {required: true, message: '请输入确认密码', trigger: 'blur'},
                        {validator: isPassword, trigger: 'blur'},
                    ],
                    rule_checked: [
                        {required: true, message: '请同意并勾选', trigger: 'change'}
                    ]
                },
              helpList:[],
            };
        },
		mounted() {
		    var _this = this;
		    var code = "jsaidaisd656";
		    //	codeFn = new _this.moveCode(code,_this);
		},
		created() {
		    this.getcopyRight();
      this.getHelpList();
		},

        methods: {
            getcopyRight() {
                this.$ajax({
                    'method': 'com.get.basic.common.init.init',
                }).then(res => {
                    if (res.status === 10000) {
                        this.copyRight = res.data.copyright
                    } else {
                        this.$message.error(res.info);
                    }
                    this.loading = false;
                })
            },
            getHelpList() {
                this.$ajax({
                    'method': 'com.get.basic.common.help.list',
                }).then(res => {
                    if (res.status === 10000) {
                       this.helpList = res.data.list;
                    }
                    this.loading = false;
                })
            },
            //滑动
            getOffset(box, direction) {
                var setDirection = (direction == 'top') ? 'offsetTop' : 'offsetLeft';
                var offset = box[setDirection];
                var parentBox = box.offsetParent;
                while (parentBox) {
                    offset += parentBox[setDirection];
                    parentBox = parentBox.offsetParent;
                }
                parentBox = null;
                return parseInt(offset);
            },
            moveCode(code, _this) {
                var fn = {codeVluae: code};
                var box = document.querySelector("#code-box"),
                    progress = box.querySelector("p"),
                    codeInput = box.querySelector('.code-input'),
                    evenBox = box.querySelector("span");
                //默认事件
                var boxEven = [];
                //改变手机端与pc事件类型
                var ww = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || window.screen.width;
                if (ww <= 1080 || ww <= "1080px") {
                    boxEven = ['touchstart', 'touchmove', 'touchend'];
                } else {
                    boxEven = ['mousedown', 'mousemove', 'mouseup'];
                }
                var goX, offsetLeft, deviation, evenWidth, endX;

                function moveFn(e) {
                    e.preventDefault();
                    e = (boxEven['0'] == 'touchstart') ? e.touches[0] : e || window.event;
                    endX = e.clientX - goX;
                    endX = (endX > 0) ? (endX > evenWidth) ? evenWidth : endX : 0;
                    if (endX > evenWidth * 0.7) {
                        progress.innerText = '松开验证';
                        progress.style.backgroundColor = "#66CC66";
                    } else {
                        progress.innerText = '';
                        progress.style.backgroundColor = "#FFFF99";
                    }
                    progress.style.width = endX + deviation + 'px';
                    evenBox.style.left = endX + 'px';
                }

                function removeFn() {
                    document.removeEventListener(boxEven['2'], removeFn, false);
                    document.removeEventListener(boxEven['1'], moveFn, false);
                    if (endX > evenWidth * 0.7) {
                        progress.innerText = '验证成功';
                        progress.style.width = evenWidth + deviation + 'px';
                        evenBox.style.left = evenWidth + 'px'
                        codeInput.value = fn.codeVluae;
                        evenBox.onmousedown = null;
                        _this.verification = true;
                    } else {
                        progress.style.width = '0px';
                        evenBox.style.left = '0px';
                    }
                };

                function getOffset(box, direction) {
                    var setDirection = (direction == 'top') ? 'offsetTop' : 'offsetLeft';
                    var offset = box[setDirection];
                    var parentBox = box.offsetParent;
                    while (parentBox) {
                        offset += parentBox[setDirection];
                        parentBox = parentBox.offsetParent;
                    }
                    parentBox = null;
                    return parseInt(offset);
                };
                evenBox.addEventListener(boxEven['0'], function (e) {
                    e = (boxEven['0'] == 'touchstart') ? e.touches[0] : e || window.event;
                    goX = e.clientX,
                        offsetLeft = getOffset(box, 'left'),
                        deviation = this.clientWidth,
                        evenWidth = box.clientWidth - deviation,
                        endX;
                    document.addEventListener(boxEven['1'], moveFn, false);
                    document.addEventListener(boxEven['2'], removeFn, false);
                }, false);
                fn.setCode = function (code) {
                    if (code)
                        fn.codeVluae = code;
                }
                fn.getCode = function () {
                    return fn.codeVluae;
                }
                fn.resetCode = function () {
                    evenBox.removeAttribute('style');
                    progress.removeAttribute('style');
                    codeInput.value = '';
                };
                return fn;
            },
            //滑动结束

            sendMobile() {
                if (this.ruleForm2.form_mobile === '') {
                    this.$message.error('请输入手机号码');
                    return false;
                }
                var smsParams = {
                    'method': 'com.set.merchant_user.auth.sms',
                    'data': {
                        'merchant_mobile': this.ruleForm2.form_mobile,
                        'type': this.sms_type
                    }
                };

                this.$ajax(smsParams).then(res => {
                    if (res.status === 10000) {
                        this.$message.success("发送短信成功");
                        this.sendMobileCode = false;
                        this.limit_time = 60;
                        var time_timer = setInterval(() => {
                            this.limit_time--;
                            if (this.limit_time <= 0) {
                                this.sendMobileCode = true;
                                clearInterval(time_timer);
                            }
                        }, 1000);
                    } else {
                        this.$message.error(res.info);
                    }
                });
            },
            randomNum(min, max) {
                return Math.floor(Math.random() * (max - min) + min);
            },
//         refreshCode() {
//             this.identifyCode = "";
//             this.makeCode(this.identifyCodes, 4);
//         },
//         makeCode(o, l) {
//             for (let i = 0; i < l; i++) {
//                 this.identifyCode += this.identifyCodes[
//                     this.randomNum(0, this.identifyCodes.length)
//                     ];
//             }
//         },
            submitForm(formName) {

                this.$refs[formName].validate((valid) => {
                    // if (this.verification==false) {
                    // 				this.$message("请滑动解锁","error");
                    // 				return;
                    // }
                    if (this.ruleForm2.password !== this.ruleForm2.re_password) {
                        this.$message.error('两次密码不一致');
                        return false;
                    }
                    if (valid) {
                        this.loading = true;
                        var registerParams = {
                            'method': 'com.set.merchant_user.auth.register',
                            'data': {
                                'merchant_mobile': this.ruleForm2.form_mobile,
                                'verify_code': this.ruleForm2.sms_code,
                                'merchant_password': md5(this.ruleForm2.password)
                            }
                        };
                        this.$ajax(registerParams).then(res => {
                            if (res.status === 10000) {
                                this.$message.success("注册成功");
                                this.$router.push({path: '/login'});
                            } else {
                                this.$message.error(res.info);
                            }
                            this.loading = false;
                        });
                    } else {
                        return false;
                    }
                });
            }
        }
    }

</script>
<style scoped>
    @import "../../styles/login.css";

    .centerCon {
        clear: both;
        margin-bottom: 28px;
    }

    .footer {
        position: fixed;
        margin-bottom: 10px
    }
</style>



// WEBPACK FOOTER //
// register.vue?2c212852